import { type ReactElement } from 'react';

const GooglePlayBadge = (): ReactElement => (
  <svg
    width="135"
    height="40"
    viewBox="0 0 135 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1404_29)">
      <path
        d="M130 40H5C2.2 40 0 37.8 0 35V5C0 2.2 2.2 0 5 0H130C132.8 0 135 2.2 135 5V35C135 37.7 132.8 40 130 40Z"
        fill="black"
      />
      <path
        d="M130 0.8C132.3 0.8 134.2 2.7 134.2 5V35C134.2 37.3 132.3 39.2 130 39.2H5C2.7 39.2 0.8 37.3 0.8 35V5C0.8 2.7 2.7 0.8 5 0.8H130ZM130 0H5C2.2 0 0 2.2 0 5V35C0 37.8 2.2 40 5 40H130C132.8 40 135 37.8 135 35V5C135 2.2 132.8 0 130 0Z"
        fill="#A6A6A6"
      />
      <path
        d="M47.4 10.2C47.4 11 47.2 11.7 46.7 12.2C46.1 12.8 45.4 13.1 44.5 13.1C43.6 13.1 42.9 12.8 42.3 12.2C41.7 11.6 41.4 10.9 41.4 10C41.4 9.10002 41.7 8.40002 42.3 7.80002C42.9 7.20002 43.6 6.90002 44.5 6.90002C44.9 6.90002 45.3 7.00002 45.7 7.20002C46.1 7.40002 46.4 7.60002 46.6 7.90002L46.1 8.40002C45.7 7.90002 45.2 7.70002 44.5 7.70002C43.9 7.70002 43.3 7.90002 42.9 8.40002C42.4 8.80002 42.2 9.40002 42.2 10.1C42.2 10.8 42.4 11.4 42.9 11.8C43.4 12.2 43.9 12.5 44.5 12.5C45.2 12.5 45.7 12.3 46.2 11.8C46.5 11.5 46.7 11.1 46.7 10.6H44.5V9.80002H47.4C47.4 9.90002 47.4 10.1 47.4 10.2Z"
        fill="white"
        stroke="white"
        strokeWidth="0.2"
        strokeMiterlimit="10"
      />
      <path
        d="M52 7.7H49.3V9.6H51.8V10.3H49.3V12.2H52V13H48.5V7H52V7.7Z"
        fill="white"
        stroke="white"
        strokeWidth="0.2"
        strokeMiterlimit="10"
      />
      <path
        d="M55.3 13H54.5V7.7H52.8V7H57V7.7H55.3V13Z"
        fill="white"
        stroke="white"
        strokeWidth="0.2"
        strokeMiterlimit="10"
      />
      <path
        d="M59.9 13V7H60.7V13H59.9Z"
        fill="white"
        stroke="white"
        strokeWidth="0.2"
        strokeMiterlimit="10"
      />
      <path
        d="M64.1 13H63.3V7.7H61.6V7H65.7V7.7H64V13H64.1Z"
        fill="white"
        stroke="white"
        strokeWidth="0.2"
        strokeMiterlimit="10"
      />
      <path
        d="M73.6 12.2C73 12.8 72.3 13.1 71.4 13.1C70.5 13.1 69.8 12.8 69.2 12.2C68.6 11.6 68.3 10.9 68.3 10C68.3 9.10002 68.6 8.40002 69.2 7.80002C69.8 7.20002 70.5 6.90002 71.4 6.90002C72.3 6.90002 73 7.20002 73.6 7.80002C74.2 8.40002 74.5 9.10002 74.5 10C74.5 10.9 74.2 11.6 73.6 12.2ZM69.8 11.7C70.2 12.1 70.8 12.4 71.4 12.4C72 12.4 72.6 12.2 73 11.7C73.4 11.3 73.7 10.7 73.7 10C73.7 9.30002 73.5 8.70002 73 8.30002C72.6 7.90002 72 7.60002 71.4 7.60002C70.8 7.60002 70.2 7.80002 69.8 8.30002C69.4 8.70002 69.1 9.30002 69.1 10C69.1 10.7 69.3 11.3 69.8 11.7Z"
        fill="white"
        stroke="white"
        strokeWidth="0.2"
        strokeMiterlimit="10"
      />
      <path
        d="M75.6 13V7H76.5L79.4 11.7V10.5V7H80.2V13H79.4L76.3 8.1V9.3V13H75.6Z"
        fill="white"
        stroke="white"
        strokeWidth="0.2"
        strokeMiterlimit="10"
      />
      <path
        d="M68.1 21.8C65.7 21.8 63.8 23.6 63.8 26.1C63.8 28.5 65.7 30.4 68.1 30.4C70.5 30.4 72.4 28.6 72.4 26.1C72.4 23.5 70.5 21.8 68.1 21.8ZM68.1 28.6C66.8 28.6 65.7 27.5 65.7 26C65.7 24.5 66.8 23.4 68.1 23.4C69.4 23.4 70.5 24.4 70.5 26C70.5 27.5 69.4 28.6 68.1 28.6ZM58.8 21.8C56.4 21.8 54.5 23.6 54.5 26.1C54.5 28.5 56.4 30.4 58.8 30.4C61.2 30.4 63.1 28.6 63.1 26.1C63.1 23.5 61.2 21.8 58.8 21.8ZM58.8 28.6C57.5 28.6 56.4 27.5 56.4 26C56.4 24.5 57.5 23.4 58.8 23.4C60.1 23.4 61.2 24.4 61.2 26C61.2 27.5 60.1 28.6 58.8 28.6ZM47.7 23.1V24.9H52C51.9 25.9 51.5 26.7 51 27.2C50.4 27.8 49.4 28.5 47.7 28.5C45 28.5 43 26.4 43 23.7C43 21 45.1 18.9 47.7 18.9C49.1 18.9 50.2 19.5 51 20.2L52.3 18.9C51.2 17.9 49.8 17.1 47.8 17.1C44.2 17.1 41.1 20.1 41.1 23.7C41.1 27.3 44.2 30.3 47.8 30.3C49.8 30.3 51.2 29.7 52.4 28.4C53.6 27.2 54 25.5 54 24.2C54 23.8 54 23.4 53.9 23.1H47.7ZM93.1 24.5C92.7 23.5 91.7 21.8 89.5 21.8C87.3 21.8 85.5 23.5 85.5 26.1C85.5 28.5 87.3 30.4 89.7 30.4C91.6 30.4 92.8 29.2 93.2 28.5L91.8 27.5C91.3 28.2 90.7 28.7 89.7 28.7C88.7 28.7 88.1 28.3 87.6 27.4L93.3 25L93.1 24.5ZM87.3 25.9C87.3 24.3 88.6 23.4 89.5 23.4C90.2 23.4 90.9 23.8 91.1 24.3L87.3 25.9ZM82.6 30H84.5V17.5H82.6V30ZM79.6 22.7C79.1 22.2 78.3 21.7 77.3 21.7C75.2 21.7 73.2 23.6 73.2 26C73.2 28.4 75.1 30.2 77.3 30.2C78.3 30.2 79.1 29.7 79.5 29.2H79.6V29.8C79.6 31.4 78.7 32.3 77.3 32.3C76.2 32.3 75.4 31.5 75.2 30.8L73.6 31.5C74.1 32.6 75.3 34 77.4 34C79.6 34 81.4 32.7 81.4 29.6V22H79.6V22.7ZM77.4 28.6C76.1 28.6 75 27.5 75 26C75 24.5 76.1 23.4 77.4 23.4C78.7 23.4 79.7 24.5 79.7 26C79.7 27.5 78.7 28.6 77.4 28.6ZM101.8 17.5H97.3V30H99.2V25.3H101.8C103.9 25.3 105.9 23.8 105.9 21.4C105.9 19 103.9 17.5 101.8 17.5ZM101.9 23.5H99.2V19.2H101.9C103.3 19.2 104.1 20.4 104.1 21.3C104 22.4 103.2 23.5 101.9 23.5ZM113.4 21.7C112 21.7 110.6 22.3 110.1 23.6L111.8 24.3C112.2 23.6 112.8 23.4 113.5 23.4C114.5 23.4 115.4 24 115.5 25V25.1C115.2 24.9 114.4 24.6 113.6 24.6C111.8 24.6 110 25.6 110 27.4C110 29.1 111.5 30.2 113.1 30.2C114.4 30.2 115 29.6 115.5 29H115.6V30H117.4V25.2C117.2 23 115.5 21.7 113.4 21.7ZM113.2 28.6C112.6 28.6 111.7 28.3 111.7 27.5C111.7 26.5 112.8 26.2 113.7 26.2C114.5 26.2 114.9 26.4 115.4 26.6C115.2 27.8 114.2 28.6 113.2 28.6ZM123.7 22L121.6 27.4H121.5L119.3 22H117.3L120.6 29.6L118.7 33.8H120.6L125.7 22H123.7ZM106.9 30H108.8V17.5H106.9V30Z"
        fill="white"
      />
      <path
        d="M10.4 7.5C10.1 7.8 10 8.3 10 8.9V31C10 31.6 10.2 32.1 10.5 32.4L10.6 32.5L23 20.1V20V19.9L10.4 7.5Z"
        fill="url(#paint0_linear_1404_29)"
      />
      <path
        d="M27 24.3L22.9 20.2V20V19.9L27 15.8L27.1 15.9L32 18.7C33.4 19.5 33.4 20.8 32 21.6L27 24.3Z"
        fill="url(#paint1_linear_1404_29)"
      />
      <path
        d="M27.1 24.2L22.9 20L10.4 32.5C10.9 33 11.6 33 12.5 32.6L27.1 24.2Z"
        fill="url(#paint2_linear_1404_29)"
      />
      <path
        d="M27.1 15.8001L12.5 7.50005C11.6 7.00005 10.9 7.10005 10.4 7.60005L22.9 20.0001L27.1 15.8001Z"
        fill="url(#paint3_linear_1404_29)"
      />
      <path
        opacity="0.2"
        d="M27 24.1L12.5 32.3C11.7 32.8 11 32.7 10.5 32.3L10.4 32.4L10.5 32.5C11 32.9 11.7 33 12.5 32.5L27 24.1Z"
        fill="black"
      />
      <path
        opacity="0.12"
        d="M10.4 32.3C10.1 32 10 31.5 10 30.9V31C10 31.6 10.2 32.1 10.5 32.4V32.3H10.4Z"
        fill="black"
      />
      <path
        opacity="0.12"
        d="M32 21.3L27 24.1L27.1 24.2L32 21.4C32.7 21 33 20.5 33 20C33 20.5 32.6 20.9 32 21.3Z"
        fill="black"
      />
      <path
        opacity="0.25"
        d="M12.5 7.60003L32 18.7C32.6 19.1 33 19.5 33 20C33 19.5 32.7 19 32 18.6L12.5 7.50003C11.1 6.70003 10 7.30003 10 8.90003V9.00003C10 7.50003 11.1 6.80003 12.5 7.60003Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_1404_29"
        x1="21.7996"
        y1="8.7096"
        x2="5.0172"
        y2="25.492"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00A0FF" />
        <stop offset="0.00657445" stopColor="#00A1FF" />
        <stop offset="0.2601" stopColor="#00BEFF" />
        <stop offset="0.5122" stopColor="#00D2FF" />
        <stop offset="0.7604" stopColor="#00DFFF" />
        <stop offset="1" stopColor="#00E3FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1404_29"
        x1="33.8343"
        y1="20.0014"
        x2="9.63742"
        y2="20.0014"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFE000" />
        <stop offset="0.4087" stopColor="#FFBD00" />
        <stop offset="0.7754" stopColor="#FFA500" />
        <stop offset="1" stopColor="#FF9C00" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1404_29"
        x1="24.8269"
        y1="22.296"
        x2="2.06863"
        y2="45.0543"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF3A44" />
        <stop offset="1" stopColor="#C31162" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_1404_29"
        x1="7.29722"
        y1="0.17615"
        x2="17.4598"
        y2="10.3387"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#32A071" />
        <stop offset="0.0685" stopColor="#2DA771" />
        <stop offset="0.4762" stopColor="#15CF74" />
        <stop offset="0.8009" stopColor="#06E775" />
        <stop offset="1" stopColor="#00F076" />
      </linearGradient>
      <clipPath id="clip0_1404_29">
        <rect width="135" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default GooglePlayBadge;
